import * as React from "react";
import { format, parseISO } from "date-fns";
import { de } from "date-fns/locale";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import "./date-picker.css";

/**
 * Weissblom Datepicker — Navy/Gold-styled wrapper around Shadcn Calendar.
 *
 * value  ISO date string ("2026-08-30") or ""
 * onChange(iso: string)
 * placeholder
 * testid
 */
export function DatePicker({ value, onChange, placeholder = "Datum wählen", testid, min }) {
  const selected = value ? parseISO(value) : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="w-full text-left bg-white border border-navy/20 hover:border-navy/40 focus:border-gold focus:outline-none px-4 py-3 text-[14px] text-navy inline-flex items-center gap-3"
        >
          <svg className="w-4 h-4 text-navy-dark/50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="1" />
            <path d="M16 2v4M8 2v4M3 10h18" />
          </svg>
          {selected ? (
            <span className="text-navy">{format(selected, "d. MMMM yyyy", { locale: de })}</span>
          ) : (
            <span className="text-navy-dark/40">{placeholder}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="p-0 weissblom-datepicker w-auto">
        <Calendar
          mode="single"
          locale={de}
          weekStartsOn={1}
          selected={selected}
          onSelect={(d) => {
            if (!d) return;
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            onChange?.(`${yyyy}-${mm}-${dd}`);
          }}
          disabled={min ? { before: parseISO(min) } : undefined}
        />
      </PopoverContent>
    </Popover>
  );
}
